<template>
  <v-form v-model="valid" ref="form" @submit.prevent="login('organizer')">
    <v-row>
      <v-col cols="12">
        <!-- <label v-bind="labelProps">Email</label> -->
        <v-text-field
          v-model="form.email"
          type="email"
          :rules="[rules.required, rules.email]"
          v-bind="fieldProps2"
          placeholder="Email"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <!-- <label v-bind="labelProps">Password</label> -->
        <v-text-field
          v-model="form.password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          v-on:click:append="show = !show"
          :type="show ? 'text' : 'password'"
          :rules="[rules.required, rules.password.min]"
          v-bind="fieldProps2"
          placeholder="Password"
        >
        </v-text-field>
        <div cols="12" class="d-flex flex-row-reverse mt-1">
          <router-link
            :to="{ name: 'Forgot' }"
            style="text-decoration: underline;"
            >Forgot Password</router-link
          >
        </div>
      </v-col>

      <v-col cols="12">
        <v-btn
          :loading="loading.organizer"
          :disabled="loading.agent"
          type="submit"
          v-bind="btnProps2"
          class="primary"
          block
        >
          Sign In as Organizer
        </v-btn>
        <v-divider class="my-3" />
        <v-btn
          :loading="loading.agent"
          :disabled="loading.organizer"
          v-bind="btnProps2"
          color="primary"
          outlined
          block
          @click="login('agent')"
        >
          Sign In as Agent
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { rules, fieldProps2, btnProps2, labelProps } from "@/helpers";
import { mapActions } from "vuex";

export default {
  data: () => ({
    rules,
    fieldProps2,
    btnProps2,
    labelProps,

    form: {
      email: "",
      password: "",
    },

    loading: {
      agent: false,
      organizer: false,
    },

    show: false,
    valid: true,
  }),

  methods: {
    ...mapActions(["userAuth"]),

    async login(loginAs) {
      if (!this.$refs.form.validate()) return;

      this.loading[loginAs] = true;

      await this.userAuth({
        ...this.form,
        email: this.form.email.trim(),
        login_type: loginAs,
      })
        .then((res) => {
          if (res.message) this.$emit("authError", { msg: res.message });
        })
        .catch((err) => {
          console.error(err);
          this.$emit("authError", { msg: "Connection error!" });
        })
        .finally(() => {
          this.loading[loginAs] = false;
        });
    },
  },
};
</script>
